var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<header class=\"page-title\"><div vueinit><page-tab-title v-bind:placeholder=\"'_PAGE_TITLE_GUTACHTENVORLAGEN_LIST_'\"></page-tab-title></div><h1>{{:: vm.gettext(\"Gutachtenvorlagen verwalten\")}}</h1></header><section class=\"main col-lg-12\"><dias-table config=\"vm.gutachtenvorlagenTable\" table-name=\"'gutachtenvorlagen'\"></dias-table></section>");;return buf.join("");
}